export const processingStatuses = [
  'BEING_UPLOADED',
  'UPLOADED_FILE',
  'SENT_TO_PIPELINE',
  'OCR_PROCESSING',
  'OCR_COMPLETE',
  'TRANSFORM_COMPLETE',
  'LOADING_DATA',
];
export const invalidFileStatuses = ['RESOLVED_AS_NOT_AN_INVOICE', 'RESOLVED_AS_MISSING_REQUIRED_FIELD', 'DUPLICATE', 'RESOLVED_AS_INCONSISTENT_SHIPMENT_DATA'];
export const invalidFileResolutionStatuses = ['NOT_AN_INVOICE', 'MISSING_REQUIRED_FIELD', 'INCONSISTENT_SHIPMENT_DATA'];
